import React, { Component } from 'react';
import PropTypes from 'prop-types';

class StandardButton extends Component {
	render() { 
		const { onClick, children } = this.props;
		return <button 
			onClick = { onClick } 
			className = { this.className() }
		>{children}</button>
	}
	
	className = () => {
		const { classNameAdd } = this.props;
		const baseClass = 'pt-button';
		return classNameAdd === '' ? baseClass: baseClass + ' ' + classNameAdd;  
	}
}

StandardButton.propTypes = {
	onClick: PropTypes.func,
	classNameAdd: PropTypes.string
}

StandardButton.defaultProps = {
	classNameAdd: ''
}

export default StandardButton;



// WEBPACK FOOTER //
// ./src/components/blueprintWrappers/StandardButton.jsx